import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const emailTemplatesApi = {
  /**
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').EmailTemplate[]>>}
   */
  list: (config) => mod.get('/email-templates/', config),

  /** @param {number} id */
  get: (id, config) => mod.get(`/email-templates/${id}`, config),

  /**
   * @param {{
   *   name: string;
   *   short_description: string;
   *   tag?: string;
   *   from_email?: string;
   *   subject?: string;
   *   body_paragraphs?: string[];
   *   accent?: 'neutral'|'amber'|'cyan'|'rose';
   * }} body
   */
  create: (body, config) => mod.post('/email-templates/', body, config),

  /** @param {number} id */
  update: (id, body, config) => mod.put(`/email-templates/${id}`, body, config),

  /** @param {number} id */
  remove: (id, config) => mod.delete(`/email-templates/${id}`, config),

  /** Mark template as the moderator's default. @param {number} id */
  setDefault: (id, config) =>
    mod.post(`/email-templates/${id}/set-default`, null, config),

  /**
   * Assign a template to a subscriber (pass null templateId to reset to default).
   * @param {number} subscriberId
   * @param {number|null} templateId
   */
  assignToSubscriber: (subscriberId, templateId, config = {}) =>
    mod.patch(`/email-templates/assign/${subscriberId}`, null, {
      ...config,
      params: { template_id: templateId, ...config.params },
    }),
};
